#import "src/queries/fragments/tagFragment.graphql"

fragment CachedTagFragment on Tag {
  id
  displayValue
}
